import React, { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaSun, FaCloud, FaCloudRain, FaSnowflake } from 'react-icons/fa';
import './Weather.css';

const KYIV_COORDS = {
  latitude: 50.4501,
  longitude: 30.5234
};

function Weather() {
  const[weather, setWeather] = useState({
    description: 'Loading...',
    tempC: '--',
    tempF: '--',
    aqi: '--',
    humidity: '--',
    main: 'Clear'
  });

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const apiKey = '11514efdda8a32caf2b9c9a3ab7848ed';

        const weatherUrl = `https://api.openweathermap.org/data/2.5/weather?lat=${KYIV_COORDS.latitude}&lon=${KYIV_COORDS.longitude}&units=metric&lang=en&appid=${apiKey}`;
        const weatherRes = await fetch(weatherUrl);
        const weatherData = await weatherRes.json();

        const aqiUrl = `https://api.openweathermap.org/data/2.5/air_pollution?lat=${KYIV_COORDS.latitude}&lon=${KYIV_COORDS.longitude}&appid=${apiKey}`;
        const aqiRes = await fetch(aqiUrl);
        const aqiData = await aqiRes.json();

        const tempC = weatherData.main.temp;
        const tempF = (tempC * 9/5) + 32;

        setWeather({
          description: weatherData.weather[0].description,
          main: weatherData.weather[0].main,
          tempC: tempC.toFixed(1),
          tempF: tempF.toFixed(1),
          humidity: weatherData.main.humidity,
          aqi: aqiData.list[0].main.aqi
        });
      } catch (error) {
        console.error('Weather fetch error:', error);
      }
    };

    fetchWeather();
    const interval = setInterval(fetchWeather, 300000);
    return () => clearInterval(interval);
  },[]);

  const getWeatherIcon = () => {
    const main = weather.main.toLowerCase();
    if (main.includes('cloud')) return <FaCloud size={14} />;
    if (main.includes('rain') || main.includes('drizzle')) return <FaCloudRain size={14} />;
    if (main.includes('snow')) return <FaSnowflake size={14} />;
    return <FaSun size={14} />;
  };

  const getAqiLabel = (aqi) => {
    const labels = { 1: 'Good', 2: 'Fair', 3: 'Moderate', 4: 'Poor', 5: 'Very Poor' };
    return labels[aqi] || aqi;
  };

  return (
      <div className="weather-container">
        <div className="weather-header-custom">
          <div className="weather-left">
            {getWeatherIcon()} <span>Weather</span>
          </div>
          <div className="weather-right">
            <FaMapMarkerAlt size={12} /> <span>Kyiv, Ukraine</span>
          </div>
        </div>

        <div className="weather-main-status">
          {weather.description.charAt(0).toUpperCase() + weather.description.slice(1)}
        </div>

        <div className="weather-details">
          <div className="weather-row">
            <span className="weather-label">Temperature:</span>
            <span className="weather-value">{weather.tempC} °C</span>
          </div>
          <div className="weather-row">
            <span className="weather-label">Humidity:</span>
            <span className="weather-value">{weather.humidity}%</span>
            <span className="weather-dot" style={{ margin: '0 8px' }}>•</span>
            <span className="weather-label">Air Quality:</span>
            <span className="weather-value">{getAqiLabel(weather.aqi)}</span>
          </div>
        </div>
      </div>
  );
}

export default Weather;